var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import Icon from './IconBase';
var TYPE;
(function (TYPE) {
    TYPE[TYPE["left"] = 0] = "left";
    TYPE[TYPE["up"] = 1] = "up";
    TYPE[TYPE["right"] = 2] = "right";
    TYPE[TYPE["down"] = 3] = "down";
})(TYPE || (TYPE = {}));
var IconStyled = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  polyline {\n    transform-origin: 50% 50%;\n    transform: rotate(", "deg);\n    transition: transform linear ", "s;\n  }\n"], ["\n  polyline {\n    transform-origin: 50% 50%;\n    transform: rotate(", "deg);\n    transition: transform linear ", "s;\n  }\n"])), function (_a) {
    var $deg = _a.$deg;
    return $deg;
}, function (_a) {
    var $rotation = _a.$rotation;
    return $rotation;
});
// const IconStyled = styled(Icon).attrs(({ $deg, $rotation }) => ({
//     style: {
//         transition: `transform linear ${$rotation}s`,
//         transform: `rotate(${$deg}deg)`
//     }
// }))``;
function ChevronIcon(_a) {
    var _b = _a.type, type = _b === void 0 ? 'left' : _b, width = _a.width, height = _a.height, props = __rest(_a, ["type", "width", "height"]);
    var lastType = useRef(type);
    var _c = __read(useState(TYPE[type] * 90), 2), deg = _c[0], setDeg = _c[1];
    var _d = __read(useState(0), 2), rotation = _d[0], setRotation = _d[1];
    useEffect(function () {
        if (type) {
            var diff = TYPE[type] - TYPE[lastType.current];
            var rotation_1 = Math.abs(diff) > 2 ? (-1 * diff) / 3 : diff;
            setDeg(function (deg) { return deg + rotation_1 * 90; });
            setRotation(rotation_1);
            lastType.current = type;
        }
    }, [type]);
    var size = width || height || 10;
    return (React.createElement(IconStyled, __assign({ "data-icon": "chevron-" + type, viewBox: '0 0 20 20', "$deg": deg, "$rotation": Math.abs(rotation / 2), stroke: 'currentColor', strokeWidth: '3', strokeLinecap: 'round', strokeLinejoin: 'round', width: size, height: size }, props, { fill: 'none' }),
        React.createElement("polyline", { points: '13 16 7 10 13 4' })));
}
export default styled(ChevronIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
